import React, { useCallback } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import Label from "./LabelF";
import "react-datepicker/dist/react-datepicker.css";
//import "../filtros.scss";
import ar from "date-fns/locale/es";
import { parseISOString } from "../../../context/FuncionesContext";

import { TextField } from "@mui/material";
registerLocale("ar", ar);

const Fecha = (props) => {
  const {
    id_a,
    setValor,
    valor,
    operador,
    componente,
    grid_span,
    error,
    setError,
  } = props;

  const parseFecha = useCallback((fecha) => {
    if (!fecha) return [null];

    try {
      if (Array.isArray(JSON.parse(fecha))) {
        let fechas = JSON.parse(fecha);

        if (fechas[0]) fechas[0] = parseISOString(fechas[0]);
        if (fechas[1]) fechas[1] = parseISOString(fechas[1]);
        return fechas;
      }
      return [parseISOString(fecha)];
    } catch (e) {
      return [parseISOString(fecha)];
    }
  }, []);

  const startDate = parseFecha(valor)[0];

  const endDate = parseFecha(valor)[1];

  const styles = {
    gridColumn: grid_span,
  };

  return (
    <div style={styles}>
      <div className="filtro_grid_fecha">
        <Label
          label={props.label}
          opcionales_null={props.opcionales_null}
          permite_null={props.permite_null}
        />

        <DatePicker
          showTimeSelect={operador !== "fecha"}
          timeFormat="p"
          timeIntervals={15}
          dateFormat="Pp"
          locale="ar"
          placeholderText={" Desde"}
          selected={valor ? startDate : null}
          onChange={(date) => {
            //setStartDate(date);
            setError((e) => {
              return { ...e, [id_a]: false };
            });
            setValor((prevState) => {
              if (!date?.toISOString().trim()) {
                return { ...prevState, [id_a]: "" };
              }
              if (componente === "fecha_simple") {
                return {
                  ...prevState,
                  [id_a]: date?.toISOString(),
                };
              }

              let fechas = [];
              if (prevState[id_a]) {
                fechas = JSON.parse(prevState[id_a]);
              }
              fechas[0] = date?.toISOString();

              return {
                ...prevState,
                [id_a]: JSON.stringify(fechas),
              };
            });
          }}
          selectsStart
          startDate={valor ? startDate : null}
          endDate={valor ? endDate : null}
          customInput={
            <TextField
              style={{ marginBottom: "8px" }}
              className={error[id_a] ? "filtro_fecha_input_error" : ""}
              label="Desde"
            />
          }
          isClearable
          label="Desde"
          withPortal
        />
        {componente === "fecha_simple" ? null : (
          <DatePicker
            showTimeSelect={operador === "fecha_hora"}
            timeFormat="p"
            timeIntervals={15}
            dateFormat="Pp"
            locale="ar"
            placeholderText={" Hasta"}
            selected={valor ? endDate : null}
            onChange={(date) => {
              //setEndDate(date);
              setValor((prevState) => {
                let fechas = [];

                if (prevState[id_a]) {
                  fechas = JSON.parse(prevState[id_a]);
                }

                fechas[1] = date?.toISOString();

                return {
                  ...prevState,
                  [id_a]: JSON.stringify(fechas),
                };
              });
            }}
            selectsEnd
            startDate={valor ? startDate : null}
            endDate={valor ? endDate : null}
            minDate={valor ? startDate : null}
            customInput={
              <TextField
                label="Hasta"
                className={error[id_a] ? "filtro_fecha_input_error" : ""}
              />
            }
            isClearable
            withPortal
          />
        )}
      </div>
    </div>
  );
};

export default Fecha;
